import React, { memo, useEffect, useRef } from 'react';
import { log } from 'log';
import { compose } from 'ramda';
import { require } from 'js/backbone/portlets';
import { componentService } from 'js/services/component.service';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';
import { withPortlet, usePortletConfig } from 'js/components/system/Portlet';

import { BONUS_MULTIVIEW } from './constants';

const BonusMultiviewWrapper = () => {
    const elRef = useRef();
    const config = usePortletConfig();
    const bonusMultiviewView = useRef();

    useEffect(() => {
        require(['portlets_bonus_multiview_bonus_multiview_model'], (Model) => {
            try {
                const model = new Model({ config, ...config }, { parse: true });
                const view = model.getView();

                view.setElement(elRef.current).onFetchRender();
                bonusMultiviewView.current = view;
            } catch (error) {
                log('error', error);
            }
        });
    }, [config]);

    useEffect(() => () => {
        bonusMultiviewView?.current?.close();
    }, []);

    return <BackboneWrapper el={elRef} />;
};

export const BonusMultiview = compose(
    memo,
    withPortlet()
)(BonusMultiviewWrapper);

componentService.registerPageComponents({ [BONUS_MULTIVIEW]: BonusMultiview });
